export default __webpack_public_path__ + "static/media/day3.46104016.png";